namespace Nobox.Web.Hubs {
    export interface MessageMedia {
        data?: string;
        mimetype?: string;
        filename?: string;
    }
}
